/** @todo test */

/** Logs a new Error with additional properties */
export function logError(
  message: string,
  // the cause for the new error may be provided
  { cause, level, ...customProperties }: AdditionalLogErrorParams,
): undefined;

/** Logs an existing Error with additional properties */
export function logError(
  err: Error, // err may have its own cause
  { level, ...customProperties }: AdditionalLogErrorParams,
): undefined;

// the explicit overloads below (without extra arguments) allow for a better DX
// e.g. `function logError(message: string, { cause, level, ...customProperties }`

/** Logs a new Error without additional properties */
export function logError(message: string): undefined;

/** Logs an existing Error without additional properties */
export function logError(
  err: Error, // err may have its own cause
): undefined;

/** implements the above signature overloads */
export function logError(
  err: Error | string,
  {
    cause,
    level = 'error',
    ...customProperties
  }: AdditionalLogErrorParams = {},
) {
  const error = err instanceof Error ? err : new Error(err, { cause });

  Object.assign(error, customProperties);

  const serializedError = JSON.stringify(error, jsonFriendlyErrorReplacer, 2)
    .replace(/\\n/g, '\n')
    .replace(/["\\]/g, '');

  console[level](serializedError);
}

type AdditionalLogErrorParams = {
  level?: 'error' | 'warn';
  /** should be an Error that explains the current error */
  cause?: unknown;

  [key: string]: unknown;
};

/** allows recursive serialization for Error.cause */
function jsonFriendlyErrorReplacer(_: unknown, value: unknown) {
  if (value instanceof Error) {
    const mainMessage = `[${value.name}: ${value.message}]`;

    // All enumerable properties
    const customProperties = { ...value };

    return Object.keys(customProperties).length || value.cause
      ? `${mainMessage} ${JSON.stringify(
          {
            ...customProperties,
            // all of Errors native properties are not enumerable
            cause: value.cause,
          },
          jsonFriendlyErrorReplacer,
          2,
        )}`
      : mainMessage;
  }

  return value;
}
